import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router";
import * as Sentry from "@sentry/react";
import { AppVersionNotifier } from "@insights/app-version";
import { ThemeProvider, initializeTheme } from "@insights/ui";
import { App } from "./app";
import {
  browserRuntimeConfig,
  createBrowserSentryOptions,
} from "./api/runtime-config.js";
import "@insights/ui/styles.css";
import "./shared/styles/global.css";
initializeTheme();
const sentryOptions = createBrowserSentryOptions(browserRuntimeConfig);

if (sentryOptions) {
  Sentry.init(sentryOptions);
}
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <AppVersionNotifier />
      <QueryClientProvider client={new QueryClient()}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
